import { combineReducers } from "redux";
import { connectRouter } from "connected-react-router";

import Common from "us.common";
import { History } from "history";
import { globalSearch } from "reducers/GlobalSearch";

const reducers = {
  ...Common.Reducers,
  globalSearch
};

const rootReducer = (history: History) =>
  combineReducers({
    router: connectRouter(history),
    ...reducers,
  });

export default rootReducer;
